// Colorful themed SVG illustrations for the gallery.
// Zero external dependencies, guaranteed no-people, on-brand.

const themes = {
  crayons: {
    bg: "#FFE9E1",
    render: (
      <g>
        {["#EF476F","#FFD166","#06D6A0","#4CC9F0","#B892FF","#F78C6B"].map((c,i)=>(
          <g key={i} transform={`translate(${30+i*36} 60) rotate(${-8+i*3})`}>
            <rect x="0" y="0" width="26" height="140" rx="4" fill={c} stroke="#2B2D42" strokeWidth="3"/>
            <polygon points="0,0 26,0 13,-22" fill={c} stroke="#2B2D42" strokeWidth="3"/>
            <rect x="0" y="30" width="26" height="14" fill="#2B2D42" opacity="0.15"/>
          </g>
        ))}
      </g>
    ),
  },
  blocks: {
    bg: "#E8FBF5",
    render: (
      <g>
        <rect x="60" y="150" width="90" height="90" fill="#EF476F" stroke="#2B2D42" strokeWidth="3" rx="8"/>
        <text x="105" y="210" textAnchor="middle" fontFamily="Fredoka" fontSize="60" fontWeight="700" fill="#fff">A</text>
        <rect x="170" y="150" width="90" height="90" fill="#FFD166" stroke="#2B2D42" strokeWidth="3" rx="8"/>
        <text x="215" y="210" textAnchor="middle" fontFamily="Fredoka" fontSize="60" fontWeight="700" fill="#2B2D42">B</text>
        <rect x="115" y="55" width="90" height="90" fill="#06D6A0" stroke="#2B2D42" strokeWidth="3" rx="8" transform="rotate(-6 160 100)"/>
        <text x="160" y="115" textAnchor="middle" fontFamily="Fredoka" fontSize="60" fontWeight="700" fill="#fff" transform="rotate(-6 160 100)">C</text>
        <rect x="225" y="55" width="90" height="90" fill="#4CC9F0" stroke="#2B2D42" strokeWidth="3" rx="8" transform="rotate(5 270 100)"/>
        <text x="270" y="115" textAnchor="middle" fontFamily="Fredoka" fontSize="60" fontWeight="700" fill="#2B2D42" transform="rotate(5 270 100)">1</text>
      </g>
    ),
  },
  books: {
    bg: "#FFF3D6",
    render: (
      <g>
        {[{c:"#EF476F",h:180,x:60},{c:"#FFD166",h:210,x:110},{c:"#06D6A0",h:160,x:160},{c:"#4CC9F0",h:200,x:210},{c:"#B892FF",h:175,x:260},{c:"#F78C6B",h:190,x:310}].map((b,i)=>(
          <g key={i}>
            <rect x={b.x} y={260-b.h} width="40" height={b.h} fill={b.c} stroke="#2B2D42" strokeWidth="3" rx="3"/>
            <rect x={b.x+6} y={260-b.h+20} width="28" height="4" fill="#2B2D42" opacity="0.25"/>
            <rect x={b.x+6} y={260-b.h+35} width="28" height="4" fill="#2B2D42" opacity="0.25"/>
          </g>
        ))}
        <rect x="30" y="260" width="340" height="18" fill="#2B2D42" rx="3"/>
      </g>
    ),
  },
  abc: {
    bg: "#F0E7FF",
    render: (
      <g>
        {[
          {t:"A", x:70, y:130, c:"#EF476F", r:-8},
          {t:"B", x:170, y:100, c:"#FFD166", r:6},
          {t:"C", x:270, y:135, c:"#06D6A0", r:-4},
          {t:"1", x:100, y:230, c:"#4CC9F0", r:5},
          {t:"2", x:200, y:255, c:"#B892FF", r:-6},
          {t:"3", x:300, y:230, c:"#F78C6B", r:4},
        ].map((l,i)=>(
          <g key={i} transform={`translate(${l.x} ${l.y}) rotate(${l.r})`}>
            <circle cx="0" cy="0" r="34" fill={l.c} stroke="#2B2D42" strokeWidth="3"/>
            <text x="0" y="14" textAnchor="middle" fontFamily="Fredoka" fontSize="42" fontWeight="700" fill="#fff">{l.t}</text>
          </g>
        ))}
      </g>
    ),
  },
  stars: {
    bg: "#FFF7DE",
    render: (
      <g>
        {[
          {x:80,y:80,s:1,c:"#FFD166"},
          {x:280,y:70,s:0.7,c:"#EF476F"},
          {x:200,y:130,s:1.4,c:"#FFD166"},
          {x:90,y:220,s:0.9,c:"#06D6A0"},
          {x:300,y:230,s:1.1,c:"#4CC9F0"},
          {x:170,y:280,s:0.8,c:"#B892FF"},
        ].map((s,i)=>(
          <polygon key={i}
            points="0,-30 8,-9 30,-9 12,4 20,26 0,14 -20,26 -12,4 -30,-9 -8,-9"
            fill={s.c} stroke="#2B2D42" strokeWidth="3"
            transform={`translate(${s.x} ${s.y}) scale(${s.s})`}/>
        ))}
      </g>
    ),
  },
  balloons: {
    bg: "#E1F4FF",
    render: (
      <g>
        {[{x:100,c:"#EF476F"},{x:200,c:"#FFD166"},{x:300,c:"#06D6A0"}].map((b,i)=>(
          <g key={i}>
            <ellipse cx={b.x} cy="130" rx="45" ry="55" fill={b.c} stroke="#2B2D42" strokeWidth="3"/>
            <polygon points={`${b.x-6},180 ${b.x+6},180 ${b.x},195`} fill={b.c} stroke="#2B2D42" strokeWidth="3"/>
            <path d={`M ${b.x} 195 Q ${b.x-14} 235, ${b.x+8} 280`} stroke="#2B2D42" strokeWidth="2" fill="none"/>
          </g>
        ))}
      </g>
    ),
  },
  palette: {
    bg: "#FFECEC",
    render: (
      <g transform="translate(200 160)">
        <path d="M -110 -30 C -110 -90, -30 -110, 20 -100 C 90 -85, 120 -20, 100 40 C 85 90, 20 100, -20 80 C -30 75, -30 60, -20 50 C 0 30, -10 10, -35 15 C -80 25, -110 15, -110 -30 Z"
              fill="#FFF7E8" stroke="#2B2D42" strokeWidth="3"/>
        {[["#EF476F",-60,-40],["#FFD166",-20,-60],["#06D6A0",30,-50],["#4CC9F0",50,-10],["#B892FF",20,30]].map(([c,x,y],i)=>(
          <circle key={i} cx={x} cy={y} r="14" fill={c} stroke="#2B2D42" strokeWidth="2.5"/>
        ))}
        <rect x="70" y="20" width="12" height="90" fill="#B08968" stroke="#2B2D42" strokeWidth="3" transform="rotate(20 76 65)"/>
        <path d="M 90 8 L 100 -2 L 110 8 L 100 18 Z" fill="#EF476F" stroke="#2B2D42" strokeWidth="3" transform="rotate(20 100 8)"/>
      </g>
    ),
  },
  sun: {
    bg: "#FFF6CC",
    render: (
      <g transform="translate(200 160)">
        {Array.from({length:12}).map((_,i)=>{
          const a=(i/12)*Math.PI*2;
          const x1=Math.cos(a)*80, y1=Math.sin(a)*80;
          const x2=Math.cos(a)*115, y2=Math.sin(a)*115;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#FFD166" strokeWidth="10" strokeLinecap="round"/>;
        })}
        <circle cx="0" cy="0" r="65" fill="#FFD166" stroke="#2B2D42" strokeWidth="3"/>
        <circle cx="-18" cy="-8" r="5" fill="#2B2D42"/>
        <circle cx="18" cy="-8" r="5" fill="#2B2D42"/>
        <path d="M -22 12 Q 0 32 22 12" stroke="#2B2D42" strokeWidth="4" fill="none" strokeLinecap="round"/>
      </g>
    ),
  },
  puzzle: {
    bg: "#E9FFF3",
    render: (
      <g transform="translate(90 90)">
        {[["#EF476F",0,0],["#4CC9F0",100,0],["#FFD166",0,100],["#06D6A0",100,100]].map(([c,x,y],i)=>(
          <rect key={i} x={x} y={y} width="100" height="100" fill={c} stroke="#2B2D42" strokeWidth="3" rx="12"/>
        ))}
        <circle cx="100" cy="100" r="18" fill="#FFF7E8" stroke="#2B2D42" strokeWidth="3"/>
      </g>
    ),
  },
  banana: {
    bg: "#FFF0F5",
    render: (
      <g>
        <path d="M 80 240 C 60 180, 100 100, 200 90 C 240 88, 280 100, 320 130 L 300 150 C 280 130, 250 120, 220 125 C 160 135, 140 200, 160 250 Z"
          fill="#FFD166" stroke="#2B2D42" strokeWidth="3"/>
        <path d="M 200 88 L 220 60 L 215 82" fill="#8B6F47" stroke="#2B2D42" strokeWidth="3"/>
        <circle cx="140" cy="290" r="20" fill="#EF476F" stroke="#2B2D42" strokeWidth="3"/>
        <circle cx="290" cy="280" r="16" fill="#06D6A0" stroke="#2B2D42" strokeWidth="3"/>
      </g>
    ),
  },
  moon: {
    bg: "#E8ECFF",
    render: (
      <g transform="translate(200 160)">
        <path d="M 30 -70 A 80 80 0 1 0 30 70 A 60 60 0 1 1 30 -70 Z" fill="#FFD166" stroke="#2B2D42" strokeWidth="3"/>
        {[[-70,-80,3],[80,-40,4],[-90,50,3],[70,70,4],[-30,-100,2]].map(([x,y,r],i)=>(
          <circle key={i} cx={x} cy={y} r={r} fill="#B892FF" stroke="#2B2D42" strokeWidth="1.5"/>
        ))}
      </g>
    ),
  },
  hearts: {
    bg: "#FFE1EA",
    render: (
      <g>
        {[["#EF476F",100,120,1],["#FFD166",220,90,0.7],["#B892FF",290,180,0.9],["#06D6A0",150,220,0.8],["#4CC9F0",260,260,1.1]].map(([c,x,y,s],i)=>(
          <path key={i} d="M 0 20 C -25 -5, -25 -30, -10 -30 C 0 -30, 0 -20, 0 -15 C 0 -20, 0 -30, 10 -30 C 25 -30, 25 -5, 0 20 Z"
                fill={c} stroke="#2B2D42" strokeWidth="3"
                transform={`translate(${x} ${y}) scale(${s})`}/>
        ))}
      </g>
    ),
  },
};

const themeOrder = Object.keys(themes);

export function themeNameFromUrl(url = "") {
  if (typeof url !== "string" || !url.startsWith("illustration:")) return null;
  return url.replace("illustration:", "").trim() || null;
}

export default function IllustrationTile({ theme = "stars", className = "" }) {
  const t = themes[theme] || themes.stars;
  return (
    <svg
      viewBox="0 0 400 320"
      preserveAspectRatio="xMidYMid slice"
      className={`w-full h-full ${className}`}
      role="img"
    >
      <rect x="0" y="0" width="400" height="320" fill={t.bg} />
      {t.render}
    </svg>
  );
}

export { themeOrder };
